import { TypePolicies } from '@apollo/client';

const maEvaluationSurveyPolicy: TypePolicies = {
  MaterialityAssessmentEvaluationSurveyResponse: {
    keyFields: false as const,
  },
};

export default maEvaluationSurveyPolicy;
